
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import '../styles/pdfExport.css';
    // Función para descargar la tabla como PDF
    const descargarPDF = () => {
        const input = document.getElementById('tabla-eficiencia');
        if (!input) return;
        input.classList.add('pdf-export');
        
        html2canvas(input, {
            scale: 2,
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff'
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });
            
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const marginX = 10; // Margen izquierdo/derecho
            const marginY = 15; // Margen superior/inferior
            const imgWidth = pdfWidth - (marginX * 2);
            const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
            const pageContentHeight = pdfHeight - (marginY * 2); // Altura disponible por página
            
            let heightLeft = imgHeight;
            let position = marginY;
            
            // Primera página
            pdf.addImage(imgData, 'PNG', marginX, position, imgWidth, imgHeight);
            heightLeft -= pageContentHeight;
            
            // Agregar páginas adicionales si es necesario
            while (heightLeft > 0) {
                position = -(imgHeight - heightLeft) + marginY;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', marginX, position, imgWidth, imgHeight);
                heightLeft -= pageContentHeight;
            }
            
            pdf.save('eficiencia-table.pdf');
            input.classList.remove('pdf-export');
        });
    };
import React, { useState } from 'react';
import { Container, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button, CircularProgress } from '@mui/material';

const EficienciaTable = () => {
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [machineData, setMachineData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            let url = '/api/maquinas-lecturas';
            const params = [];
            if (fechaInicio) params.push(`fechaInicio=${fechaInicio}`);
            if (fechaFin) params.push(`fechaFin=${fechaFin}`);
            if (params.length > 0) url += '?' + params.join('&');
            
            console.log('Fetching eficiencia data from:', url);
            const res = await fetch(url);
            
            if (!res.ok) {
                console.error('Error en la respuesta:', res.status);
                setMachineData([]);
                setLoading(false);
                return;
            }
            
            const data = await res.json();
            console.log('Datos recibidos:', data);
            console.log('Tipo de datos:', Array.isArray(data) ? 'Array' : typeof data);
            console.log('Cantidad de máquinas:', Array.isArray(data) ? data.length : 0);
            setMachineData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error al cargar datos de eficiencia:', error);
            setMachineData([]);
        } finally {
            setLoading(false);
        }
    };

    // Eliminar el useEffect automático. Solo se carga al hacer clic en el botón Filtrar.

    // Obtener todas las fechas únicas y máquinas únicas
    let fechas = [];
    let maquinas = [];
    if (Array.isArray(machineData)) {
        const setFechas = new Set();
        const setMaquinas = new Set();
        machineData.forEach(m => {
            setMaquinas.add(m.maquinaId);
            if (Array.isArray(m.lecturas)) {
                m.lecturas.forEach(l => {
                    // El backend ahora devuelve fecha en formato YYYY-MM-DD directamente
                    if (l.fecha) {
                        setFechas.add(l.fecha);
                    }
                });
            }
        });
        fechas = Array.from(setFechas).sort();
        maquinas = Array.from(setMaquinas).sort();
        console.log('Fechas encontradas:', fechas.length, fechas);
        console.log('Máquinas encontradas:', maquinas.length, maquinas);
    }

    // Construir matriz: { fecha: { maquinaId: eficiencia } }
    const matriz = {};
    fechas.forEach(f => {
        matriz[f] = {};
    });
    machineData.forEach(m => {
        if (Array.isArray(m.lecturas)) {
            m.lecturas.forEach(l => {
                // El backend ya devuelve promedio por día
                if (l.fecha && typeof l.eficiencia === 'number') {
                    matriz[l.fecha][m.maquinaId] = l.eficiencia;
                }
            });
        }
    });

    // Calcular totales por fecha (promedio de eficiencia por fecha)
    const totalesFecha = fechas.map(f => {
        const valores = maquinas.map(m => matriz[f][m]).filter(v => typeof v === 'number');
        if (valores.length === 0) return '-';
        const promedio = valores.reduce((a, b) => a + b, 0) / valores.length;
        return promedio.toFixed(2);
    });

    // Calcular totales por máquina (promedio de eficiencia por máquina)
    const totalesMaquina = maquinas.map(m => {
        const valores = fechas.map(f => matriz[f][m]).filter(v => typeof v === 'number');
        if (valores.length === 0) return '-';
        const promedio = valores.reduce((a, b) => a + b, 0) / valores.length;
        return promedio.toFixed(2);
    });

    return (
        <Container>
            <Typography variant="h4" align="center" mb={6} mt={9} gutterBottom>
                Eficiencia Promedio
            </Typography>
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="outlined" color="secondary" onClick={descargarPDF}>
                    Descargar PDF
                </Button>
            </Box>
            <Box display="flex" gap={2} alignItems="center" mb={3} justifyContent="center">
                <TextField
                    label="Fecha inicio"
                    type="date"
                    value={fechaInicio}
                    onChange={e => setFechaInicio(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                        '& .MuiInputBase-root': {
                            backgroundColor: '#302f2fff'
                        }
                    }}
                />
                <TextField
                    label="Fecha fin"
                    type="date"
                    value={fechaFin}
                    onChange={e => setFechaFin(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                        '& .MuiInputBase-root': {
                            backgroundColor: '#302f2fff'
                        }
                    }}
                />
                <Button variant="contained" color="primary" onClick={fetchData}>
                    Filtrar
                </Button>
            </Box>
            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress />
                </Box>
            ) : machineData.length === 0 ? (
                <Typography align="center" mt={4}>
                    Selecciona un rango de fechas y presiona Filtrar para ver la tabla de eficiencia.
                </Typography>
            ) : fechas.length > 0 ? (
                    <Box id="tabla-eficiencia">
                        <Typography variant="h5" align="center" sx={{ mb: 2, color: '#555', fontWeight: 'bold' }}>
                            Eficiencia Promedio
                        </Typography>
                        <TableContainer component={Paper} sx={{ maxHeight: '600px' }}>
                            <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#074788', color: 'white' }}>Fecha</TableCell>
                                    {maquinas.map((m, idx) => (
                                        <TableCell key={idx} sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: 'white' }}>{m}</TableCell>
                                    ))}
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: 'white' }}>Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fechas.map((f, idx) => (
                                    <TableRow key={idx} sx={{ '&:hover': { backgroundColor: '#424242' } }}>
                                        <TableCell>{f}</TableCell>
                                        {maquinas.map((m, j) => (
                                            <TableCell key={j}>
                                                {matriz[f][m] !== undefined && typeof matriz[f][m] === 'number'
                                                    ? matriz[f][m].toFixed(2)
                                                    : '-'}
                                            </TableCell>
                                        ))}
                                        <TableCell sx={{ color: '#bdbdbd', fontWeight: 'bold' }}>
                                            <b>{totalesFecha[idx]}</b>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {/* Fila de totales por máquina */}
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: '#e0e0e0' }}>
                                        <b>Total</b>
                                    </TableCell>
                                    {totalesMaquina.map((total, idx) => (
                                        <TableCell key={idx} sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: '#e0e0e0' }}>
                                            <b>{total}</b>
                                        </TableCell>
                                    ))}
                                    <TableCell sx={{ backgroundColor: '#071525' }}></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Box>
                ) : (
                    <Typography align="center" mt={4}>
                        No hay datos de eficiencia para los filtros seleccionados. Nota: Solo las máquinas 1-8 tienen datos de eficiencia.
                    </Typography>
                )}
        </Container>
    );
};

export default EficienciaTable;